import React from 'react';
import { useTranslation } from "react-i18next";
import HeadingBuilder from './HeadingBuilder';

export const ClipboardButton = ({
  textToCopy, getTextToCopy, xformTextFn, buttonType
}) => {

  const { t } = useTranslation();

  // Copying clipboard contents saves what is on the screen "now". But when is
  // "now"? Is it at the current time when we define the function? Is it later
  // on when maybe the screen appearance has changed, and it's that material
  // that the shopper wants to copy?
  // To avoid locking in on the text that is in the area of interest right now,
  // let 'buttonAction' be loaded with a function that will be run later (at the
  // time of need.) If the caller is fine with the existing text as what to
  // copy, i.e. no 'getTextToCopy' function is passed, we can push 'textToCopy'
  // out as it is, so no need to run a function.
  // If we run a function and know the resulting text is 'messy', allow the
  // caller to direct how to clean it up via param 'xformTextFn'.
  const buttonFn =
    getTextToCopy
      ? async () => {
          const text = getTextToCopy();
          // console.log('cb gttc', text)

          const result =
            xformTextFn
              ? xformTextFn(text)
              : text;

          await navigator.clipboard.writeText(result);
        }

      : () => navigator.clipboard.writeText(textToCopy)

  return (
    // Caller designates Tippy text to show via 'buttonType'
    <HeadingBuilder
      buttonAction   = {buttonFn}
      headingText    = {t(`clipboard.${buttonType}.label`)}
      // Copy to Clipboard - e.g. for 'clipboard.feedback.label'

      tippyAlertText = {t(`clipboard.${buttonType}.tippyContent`)}
      tippyText      = {t(`clipboard.${buttonType}.tippyContent`)}
    />
  )
}

export default ClipboardButton;